<div class="container-productos">
    <h2 style="text-align: center;">Productos</h2>
    <p-table [value]="productos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th>Código</th>
                <th>Producto</th>
                <th>Folio</th>
                <th>Hospital</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-producto>
            <tr>
                <td>{{producto.fechaAplicacion | date:'dd/MM/yyyy'}}</td>
                <td>{{producto.codigo}}</td>
                <td>{{producto.nomProducto}}</td>
                <td>{{producto.casoclinico.serie}}</td>
                <td>{{producto.casoclinico.nomHospital}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron productos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>